import { render } from "./inner-lobbi.vue?vue&type=template&id=77764430"
import script from "./inner-lobbi.vue?vue&type=script&lang=js"
export * from "./inner-lobbi.vue?vue&type=script&lang=js"

import "./inner-lobbi.vue?vue&type=style&index=0&id=77764430&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__